module.exports = __webpack_public_path__ + "static/adaptibility-5067826884b00a912a0e5d1ad1226e19.jpg";